import { useCallback } from 'react';
import { useDeleteCampaignSlotMutation } from 'src/api/campaigns/hooks';
import { useGlobalModals } from 'src/contexts/global-modals';

export const useDeleteCampaignSlotModal = () => {
  const {
    deleteCampaignSlotModal,
    closeDeleteCampaignSlotModal,
    openLoadingModal,
    closeLoadingModal,
  } = useGlobalModals();
  const { deleteCampaignSlotMutation, isPending } =
    useDeleteCampaignSlotMutation();

  const open = deleteCampaignSlotModal.opened;
  const slotId = deleteCampaignSlotModal.slotId;

  const handleConfirm = useCallback(async () => {
    if (!slotId) {
      return;
    }

    openLoadingModal(
      'Deleting campaign slot',
      'Please wait while we delete the campaign slot...'
    );
    closeDeleteCampaignSlotModal();

    try {
      await deleteCampaignSlotMutation(slotId);
    } finally {
      closeLoadingModal();
    }
  }, [
    closeDeleteCampaignSlotModal,
    closeLoadingModal,
    deleteCampaignSlotMutation,
    slotId,
    openLoadingModal,
  ]);

  const handleClose = useCallback(() => {
    closeDeleteCampaignSlotModal();
  }, [closeDeleteCampaignSlotModal]);

  return {
    handleClose,
    handleConfirm,
    isPending,
    open,
  };
};
